module.exports = __webpack_public_path__ + "static/media/creeper_run.79796610.png";